module.exports = __webpack_public_path__ + "static/media/modal-background.46fa84d2.png";